import {React, useContext} from 'external/react'
import Text from 'react-text'
import {Context} from '../../../context'
import {groupPlanningPdfStandards} from 'components/standards-selector/domain/planning-pdf.cjs'

function Indicator({code, description}) {
  return <div className="indicator">
    <div className="indicator-code">{code}</div>
    <div className="indicator-name">{description}</div>
  </div>
}

function Expectation({name, description, indicators}) {
  return <div className="expectation">
    <label className="expectation-title">{name || description}</label>
    {indicators.length > 0 && <div className="indicators">
      {indicators.map(indicator => <Indicator key={indicator.id} {...indicator}/>)}
    </div>}
  </div>
}

function Standard({name, expectations}) {
  return <div className="standard">
    <label className="standard-title">{name}</label>
    <div className="expectations">
      {expectations.map(expectation => <Expectation key={expectation.id} {...expectation}/>)}
    </div>
  </div>
}

export default function Standards({standards}) {
  const context = useContext(Context)
  const groups = groupPlanningPdfStandards(standards, context.teacherExpectations, context.teacherStandards)
  return <React.Fragment>
    <div className="standards title"><Text id="planning-pdf-standards-title"/></div>
    <div className="standards">
      {groups.map(group => <div className="edition-group" key={group.id} style={{marginBottom:20}}>
        <div className="edition-heading" style={{fontWeight:'bold', color:'#294e73', background:'#eaf2fa', padding:'10px 12px', marginBottom:12}}>
          {context.translate('standards')} · {group.year}
        </div>
        {group.standards.map(standard => <Standard key={`${group.id}:${standard.id}`} {...standard}/>)}
      </div>)}
    </div>
  </React.Fragment>
}
